import React from 'react';
import PropTypes from 'prop-types';
import {FormattedNumber, FormattedMessage} from "react-intl";
import 'react-datepicker/dist/react-datepicker.css';

class Total extends React.Component {
    static propTypes = {
        value: PropTypes.number.isRequired
    };

    render() {
        const {value} = this.props;

        return (
            <div className="stats__total" style={{whiteSpace: 'pre'}}>
                <FormattedMessage id="stats.total" defaultMessage="Statistics summary"/>:
                <strong>
                    <FormattedNumber value={value} style='currency' currency='CZK'/>
                </strong>
            </div>
        )
    }
}

export default Total;


// WEBPACK FOOTER //
// ./src/containers/Stats/Total.jsx